import {getUsersCollectionPath, UserDb} from '@cp/model';
import {doc, DocumentReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

export default function getUserDocRef(uid: string): DocumentReference<UserDb> {
  return doc(firebaseFirestore, getUsersCollectionPath(), uid) as DocumentReference<UserDb>;
}
